// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const ply = {
  people_like_you: {
    contentful_name: 'People Like You (DEFAULT DO NOT CHANGE)',
    button_text: {
      openPDF: '比较计划需要什么?',
      results: '显示我的结果',
      backToResults: '返回结果',
    },
    plan_ranking: {
      texts: ['正在分析所有符合条件的计划', '正在比较适合像您这样的人的计划', '正在完成计划排名'],
      title: '为您的计划排名',
    },
    people_like_you_title: '寻找志同道合的人',
    office_visits: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '在计划年度内',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '进行过一次或多次门诊就诊',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    emergency_care: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '在计划年度内接受了',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '紧急或急诊护理',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    claim_rate: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '在计划年度内',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '入院治疗',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    hospital_rate: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '在计划年度内',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '入院治疗',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    profile_summary_title: '正在整理您的个人资料答案',
    profile_answers: {
      spouse: '您和配偶/伴侣',
      noSpouse: '承保您',
      dependent: {
        one: '1 名受抚养人',
        many: '{x} 名受抚养人',
      },
      pcpVisits: {
        one: '1 次初级保健医生就诊',
        many: '{x} 次初级保健医生就诊',
      },
      pregnancy: '预期怀孕',
      riskAversion: {
        low: '低风险规避',
        high: '高风险规避',
        moderate: '中等风险规避',
      },
      capacityToPay: {
        lt_500: '可承受少于 500 美元',
        gt_6000: '可承受超过 6,000 美元',
        '500_1000': '可承受 500 至 1,000 美元',
        '1000_2000': '可承受 1,000 至 2,000 美元',
        '2000_3000': '可承受 2,000 至 3,000 美元',
        '3000_4000': '可承受 3,000 至 4,000 美元',
        '4000_6000': '可承受 4,000 至 6,000 美元',
      },
      inpatientDays: {
        one: '1 天住院',
        many: '{x} 天住院',
      },
      prescriptions: {
        one: '1 个处方',
        many: '{x} 个处方',
      },
      specialistVisits: {
        one: '1 次专科医生就诊',
        many: '{x} 次专科医生就诊',
      },
      mentalHealthVisits: {
        one: '1 次心理健康服务提供者就诊',
        many: '{x} 次心理健康服务提供者就诊',
      },
    },
    modal_title: '您的计划适配度分析',
    spending_icons: [
      {
        plyKey: 'office_visits',
        iconText: '门诊就诊',
        inlineText: '至少有一次初级保健医生或专科医生就诊记录',
      },
      {
        plyKey: 'labs_diagnostics',
        iconText: '化验',
        inlineText: '支付了化验服务费用(例如血液检查或其他诊断性检查)',
      },
      {
        plyKey: 'emergency_urgent_care',
        iconText: '急诊',
        inlineText: '至少有一次急诊诊所或急诊室就诊记录(请注意,急诊诊所就诊更常见且费用低于急诊室就诊)',
      },
      {
        plyKey: 'inpatient',
        iconText: '住院',
        inlineText: '曾入住医院或其他住院机构',
      },
    ],
    spending_title: '您的潜在支出',
    spending_section_introduction: '以下是像您这样的人使用不同类型医疗保健服务的频率以及他们的花费情况。',
    service_utilization_text: '像您这样{x}的人群占比:',
    cost_distribution_bar_text: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '对于那些',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '%的人,这些服务的医疗账单总额从',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'underline',
                },
                {
                  type: 'bold',
                },
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '到',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'underline',
                },
                {
                  type: 'bold',
                },
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '不等。中位数费用为',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'underline',
                },
                {
                  type: 'bold',
                },
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    healthcare_usage_title: '您的医疗保健使用情况',
    healthcare_usage_description: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '为了帮助您了解自己的风险,以下是',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '像您这样的人',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '每年最终产生低、中或高水平',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '医疗支出',
              marks: [
                {
                  type: 'underline',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '的人数情况。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    healthcare_usage_distribution_text: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '大多数像您这样的人最终的医疗支出水平为 ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'bold',
                },
                {
                  type: 'code',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '。',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{}',
              marks: [
                {
                  type: 'code',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    healthcare_usage_range_descriptions: {
      low: {
        title: '低',
        symbol: '$',
        tooltip: '医疗账单总额低于$1,000。',
        description:
          '这意味着您全年的医疗账单总额可能低于$1,000。当您的医疗支出水平可能较低时,保费较低的计划将更具价值。',
      },
      high: {
        title: '高',
        symbol: '$$$',
        tooltip: '医疗账单总额超过$10,000。',
        description:
          '这意味着您全年的医疗账单总额可能达到$10,000或更多。当您的医疗支出水平可能较高时,限制您自付费用的计划将更适合您,但价格仍需合理才能体现良好价值。',
      },
      moderate: {
        title: '中等',
        symbol: '$$',
        tooltip: '医疗账单总额在$1,000至$10,000之间。',
        description:
          '这意味着您全年的医疗账单总额可能在$1,000至$10,000之间。当您的医疗支出水平可能处于中等水平时,最适合您的计划将在保费节省和保障范围之间取得平衡。',
      },
    },
    modal_button_primer_text: '预测医疗保健需求可能很困难。ALEX 会预测一系列可能的结果,为您找到最佳方案。',
    overview_title: 'ALEX如何进行预测',
    user_icon_text: 'ALEX首先识别出与您有相似医疗保健使用情况的人群。',
    costs_icon_text: '接下来,ALEX查看他们在不同服务上的支出情况。',
    ranks_icon_text: '最后,ALEX根据您的偏好对您的计划进行排名。',
    overview_explanatory_text: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                'ALEX通过分析与您相似人群的数据来预测您的医疗费用和风险,从而帮助您找到最佳方案。以下是其工作原理。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    overview_learn_more: '要了解更多关于其工作原理的信息,请继续阅读。',
    rankings_title: '您的结果',
    rankings_text: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'ALEX 通过分析与您情况相似的人群的理赔数据和消费模式,来估算您',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '典型年度的费用',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: ',以及您',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '自付费用较高的风险',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '结合',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '计划保费',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '和您的',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '财务偏好',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: ',ALEX 随后会对您的选项进行评分和排序,以找到最适合您需求的计划。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    modal_button_text: '探索ALEX的预测',
    tooltips: {
      p25: '第25百分位数:花费最少的四分之一人群支出低于此金额。',
      p50: '第50百分位数(中位数):一半人群支出低于此金额,一半人群支出高于此金额。',
      p75: '第75百分位数:花费最多的四分之一人群支出高于此金额。',
      medicalSpending: '医疗护理的总费用,包括您支付的部分和您的保险承担的部分。',
    },
    service_utilization_caveat_text:
      '请注意,这反映的是保险承保前的服务费用。请查阅计划详情以了解特定计划将如何承担此项服务的费用。',
  },
};
